export default {
  user: (store: any) => store.user || {},
};
